import useTracker from '@hooks/useTracker';
import {
  PIN_CHANGE_ACCOUNT,
  CREATE_PIN_6DIGIT,
  CONFIRM_PIN_6DIGIT,
  PIN_CREATE_VIEW,
  PIN_CREATE_SUBMIT,
  PIN_RECONFIRM_VIEW,
  PIN_RECONFIRM_SUBMIT,
  PIN_UPDATE_VIEW,
  PIN_UPDATE_SUBMIT,
  PIN_UPDATE_BANNER_VIEW,
  PIN_UPDATE_BANNER_CLICK,
  PIN_APP_SOURCE,
  PIN_STATUS,
} from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent, setUserId, resetTracker } = useTracker();

  const eventClickLogout = () => {
    trackEvent(PIN_CHANGE_ACCOUNT);
    setUserId(null);
    resetTracker();
  };

  const eventCreatePin6Digit = () => {
    trackEvent(CREATE_PIN_6DIGIT);
  };

  const eventConfirmPin6Digit = (props) => {
    trackEvent(CONFIRM_PIN_6DIGIT, props);
  };

  const eventPinCreateView = () => {
    trackEvent(PIN_CREATE_VIEW, { app_source: PIN_APP_SOURCE });
  };

  const eventPinCreateSubmit = () => {
    trackEvent(PIN_CREATE_SUBMIT, { app_source: PIN_APP_SOURCE });
  };

  const eventPinUpdateView = (entryPoint) => {
    trackEvent(PIN_UPDATE_VIEW, { app_source: PIN_APP_SOURCE, entry_point: entryPoint });
  };

  const eventPinUpdateSubmit = (entryPoint) => {
    trackEvent(PIN_UPDATE_SUBMIT, { app_source: PIN_APP_SOURCE, entry_point: entryPoint });
  };

  const eventPinReconfirmView = (entryPoint) => {
    trackEvent(PIN_RECONFIRM_VIEW, { app_source: PIN_APP_SOURCE, entry_point: entryPoint });
  };

  const eventPinReconfirmSubmit = (entryPoint, status, failReason) => {
    trackEvent(PIN_RECONFIRM_SUBMIT, {
      app_source: PIN_APP_SOURCE,
      entry_point: entryPoint,
      status,
      ...(status === PIN_STATUS.FAIL ? { fail_reason: failReason || '' } : {}),
    });
  };

  const eventPinUpdateBannerView = (entryPoint, variant) => {
    trackEvent(PIN_UPDATE_BANNER_VIEW, { entry_point: entryPoint, variant });
  };

  const eventPinUpdateBannerClick = (entryPoint, variant, click) => {
    trackEvent(PIN_UPDATE_BANNER_CLICK, { entry_point: entryPoint, variant, click });
  };

  return {
    eventClickLogout,
    eventCreatePin6Digit,
    eventConfirmPin6Digit,
    eventPinCreateView,
    eventPinCreateSubmit,
    eventPinUpdateView,
    eventPinUpdateSubmit,
    eventPinReconfirmView,
    eventPinReconfirmSubmit,
    eventPinUpdateBannerView,
    eventPinUpdateBannerClick,
  };
};

export default useEventTracker;
